"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collector = void 0;
var collector = function (result) {
    var returnArray = [];
    if (result) {
        result.forEach(function (value) {
            var _a;
            if (value.transformed) {
                var action = (_a = value.transformed.msgType) === null || _a === void 0 ? void 0 : _a.split("/")[1];
                var types = [
                    "transfer",
                    "send",
                    "delegate",
                    "undelegate",
                    "begin-redelegate",
                ];
                if (!types.includes(action)) {
                    returnArray.push(value);
                }
            }
        });
    }
    if (returnArray.length <= 0 && result) {
        return result;
    }
    else {
        return returnArray;
    }
};
exports.collector = collector;
//# sourceMappingURL=collector.js.map